<template>
  <el-row style="padding-bottom: 20px">
    <el-col :span="24" v-if="bannerList.length > 0">

      <div  v-show=" !mobiePhoneShow || !showNewsDetail "  class="my-swiper-box" >

        <div class="my-swiper-box-bg" :style="{
              '--bgImage': 'url(' + imgserver + VirtualImage + ')',
            }"  ></div>

        <swiper  v-if="bannerList.length > 0" :options="swiperOption" ref="mySwiper" class="custom-carousel"  >
          <swiper-slide v-for="(item, index) in bannerList"
                        :key="index" :index="index"    :style="{height:bannerHeight + 'rem'}"  >
            <div
                class="banner-block background-image cur-pointer"
            >
              <div class="background-image-bgbox">
                <el-image class="background-image-bg" :src="imgserver + item.url" fit="cover"></el-image>
              </div>

            </div>

          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" @click='swiperNext' slot="button-prev">
            <i class="el-icon-arrow-right" style="color: #fff;"></i>
          </div>
          <div class="swiper-button-prev" @click='swiperPrev' slot="button-next">
            <i class="el-icon-arrow-left" style="color: #fff;" ></i>
          </div>
        </swiper>

      </div>

    </el-col>

    <!-- 面包屑及搜索栏 -->
    <el-col v-if=" !mobiePhoneShow "  :span="24" class="breadcrumb-search">
      <!-- 面包屑 -->
      <div class="breadcrumb-block">
        <div class="breadcrumb-block-content">
          <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="{ path: '/' }"
            ><span>网站首页</span></el-breadcrumb-item
            >
            <el-breadcrumb-item><span>影像中心</span></el-breadcrumb-item>

            <div class="custom-bead-box"  >
              <div class="bead-box-item" @click="clickAsidMenu(item.id)" :class="asidId == item.id?'bead-box-item-active':''" v-for="(item,index) in asidMenuList" :key="item.id">
                <div >{{ item.name }}</div>
                <div v-if="index < asidMenuList.length - 1" class="bead-box-item-line"></div>
              </div>
            </div>

          </el-breadcrumb>
        </div>
      </div>
    </el-col>

    <el-col class="common-block page-content">
<!--      <div class="asid-menu-block" v-if="!mobiePhoneShow">-->
<!--        <el-menu :default-active="asidId" @select="clickAsidMenu">-->
<!--          <div v-for="item in asidMenuList" :key="item.id">-->
<!--            <el-menu-item class="asid-menu-item" :index="item.id.toString()">-->
<!--              <span slot="title">{{ item.name }}</span>-->
<!--            </el-menu-item>-->
<!--          </div>-->
<!--        </el-menu>-->
<!--      </div>-->
      <div class="asid-hor-menu-block"   v-if="mobiePhoneShow" >
        <el-menu v-if="false"
          :default-active="asidId"
          class="el-menu-demo"
          mode="horizontal"
          @select="clickAsidMenu"
        >
          <div
            v-for="item in asidMenuList"
            :key="item.id"
            style="display: inline-block"
          >
            <el-menu-item class="asid-menu-item" :index="item.id.toString()">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>

      <!-- 内容 -->
      <div class="image-block">
        <div class="image-list" >
          <div
            v-for="(item, index) in dataList"
            :key="item.id"
            class="image-item"
          >
            <div
              class="image-item-block cur-pointer"
              @click="toImageDetail(index)"
            >

              <el-image  class="image-item-img"
                         style="width: 100%" :src="imgserver + item.picUrl" fit="contain" ></el-image>

              <div style="padding: 14px" class="image-item-text">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>

        <el-dialog :visible.sync="isShowImageDetail" class="my-showimage-dialog" :destroy-on-close="true" :center="true" :append-to-body="true" @open="dialogShowImageOpen" >

          <div class="image-detail-block" >
            <div @click="isShowImageDetail=false" class="close-badge-box">
              <img  class="close-badge" src="../assets/img/close.png">
            </div>
            <div class="image-detail-carouselbox" >
              <el-carousel
                  class="image-detail-carousel"
                  direction="horizontal"
                  :height="(imgpcHeightList[initialindex] + 6) + 'px'"
                  :initial-index="initialindex"
                  @change="handlechange"
                  ref="carouseTopRef"
                  :autoplay="carousel_autoplay"
                  arrow="never"
              >
                <el-carousel-item
                    class="image-detail-carousel-item"h
                    v-for="(item,index) in tempDataList"
                    :key="index"
                >
                  <div class="image-carousel-item-icon cur-pointer" >

                    <img :ref="'imgpcRef' + index" style="width: 100%;"
                         :src="imgserver + item.picUrl"  @load="imgLoad(index)">

                  </div>
                </el-carousel-item>
              </el-carousel>

              <div  @click="moveChangeSwiper(0)" class="my-carousel-pre">
                <img src="./../assets/img/arrow-right-badge.png">
              </div>
              <div @click="moveChangeSwiper(1)" class="my-carousel-next">
                <img src="./../assets/img/arrow-right-badge.png">
              </div>

            </div>

            <div class="my-img-box" ref="myImgRef" >
              <div class="image-carousel-item-title">
                <span>
                  {{ imageTitle }}
                </span>
                <div v-if="richText" class="rich-box">
                  <div class="rich-text" v-html="richText"></div>
                </div>
              </div>
              <div class="carousel-sublist">
                <button
                    type="button"
                    @click="handleCarouselChange(0)"
                    class="carousel-sublist-btn carousel-sublist-btn-left"
                >
                  <i class="el-icon-arrow-left icon-arrow"></i>
                </button>
                <button
                    type="button"
                    @click="handleCarouselChange(1)"
                    class="carousel-sublist-btn carousel-sublist-btn-right"
                >
                  <i class="el-icon-arrow-right icon-arrow"></i>
                </button>
                <div class="carousel-sublist-layout">
                  <div class="carousel-sublist-position"  >
                    <div
                        v-for="(item, index) in tempDataList"
                        :key="item.id"
                        class="carousel-sublist-item"
                        @click="handleToggleImage(index)"
                    >
                      <div class="sublist-item-block cur-pointer"  >
                        <el-image ref="myImgItemRef" class="sublist-item-icon" :class="galleryIndex==index?'sublist-item-icon-active':''"
                                  :src="imgserver + item.picUrl" fit="cover" ></el-image>

                        <!--                    <div class="sublist-item-title">-->
                        <!--                      <span>-->
                        <!--                        {{ item.title }}-->
                        <!--                      </span>-->
                        <!--                    </div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="image-detail-block-h5">
            <div>
              <el-carousel
                  class="image-detail-carousel"
                  direction="horizontal"
                  :height="carouseHeight"
                  :initial-index="initialindex"
                  @change="handlechangeH5"
                  ref="carouseTopMobielRef"
                  arrow="always"
                  :autoplay="carousel_autoplay"
              >
                <el-carousel-item
                    class="image-detail-carousel-item"
                    v-for="item in tempDataList"
                    :key="item.id"
                >
                  <div class="image-carousel-item-icon cur-pointer">
                    <img
                        style="width: 100%; height: 100%"
                        :src="imgserver + item.picUrl"
                        alt=""
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="image-carousel-item-title">
              <span>
                {{ imageTitle }}
              </span>
              <div v-if="richText" class="rich-box">
                <div class="rich-text" v-html="richText" ></div>
              </div>
            </div>

          </div>

        </el-dialog>

        <div class="pagination-block" v-if="!isShowImageDetail && total !== 0">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="currentSize"
            layout="total, pager, jumper"
            :total="total"
            :small="pageSmallBool"
            :pager-count="pagerCount"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {
  getBannerListApi,
  getFunctionListApi,
  getDataListApi,
} from "@/api/homeApi";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import shareMethods from "@/common/shareMethods";
export default {
  name: "home",
  components: {swiper, swiperSlide},
  data() {
    return {
      funcId: "17",
      asidId: "18",
      currentPage: 1,
      currentSize: 9,
      total: 0,
      searchValue: "",
      bannerList: [],
      dataList: [],
      asidMenuList: [],
      dataIndex: 0,
      routerName: "",
      tempDataList: [],
      isShowImageDetail: false,
      initialindex: 0,
      // 获取当前轮播index + 已切换index = 即将切换的index
      tempIndex: 0,
      carouseHeight: "66rem",
      carousel_autoplay: false,
      imageTitle: "",
      richText: "",
      mobiePhoneShow: true,
      bannerHeight: 22.9,
      pageSmallBool: false,
      pagerCount: 7,

      swiperOption: {
        init:false,
        initialSlide:0,
        preloadImages:false,
        loopAdditionalSlides: 5,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:'.swiper-pagination',
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。

        },
        // notNextTick:true,
        autoplay: false,
        loop: true,

      },

      iconHeioght: 0,
      imgpcHeightList: [],

      galleryOffsetLeft: 0,
      galleryIndex: 0,
      moveMaxGap: 7,

    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = "https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = "长沙市唯上商务科技学校";
    let title = "长沙市唯上商务科技学校";
    this.share(imgUrl, linkUrl,desc, title );

    getBannerListApi(this.funcId).then((res) => {
      this.bannerList = res.data;

      this.swiperOption.autoplay = this.bannerList.length == 1?false:true;

      setTimeout(() => {
        this.$nextTick(() => {
          // 确保DOM更新后初始化Swiper
          if( this.swiper){
            this.swiper.init();
          }

        });
      }, 500)

    });
    if (this.$route.query.id) {
      this.asidId = this.$route.query.id;
    }
    this.getFuncList();
    this.handleResize();
    var tmpList = window.location.href.split("id=");
    if (tmpList.length == 1) {
    } else {
      this.asidId = tmpList[1].split("&")[0];
    }
    if (this.$route.query.type == 2) {
      this.toImageDetail(this.$route.query.index);
    }
  },
  methods: {
    handlechange(index) {

      let concatDataList = this.tempDataList;
      this.imageTitle = concatDataList[index].title;
      this.richText = concatDataList[index].detail;
      this.tempIndex = index;
      this.initialindex = index;
      this.galleryIndex = index;

    },
    handlechangeH5(index) {

      let concatDataList = this.tempDataList;
      this.imageTitle = concatDataList[index].title;
      this.richText = concatDataList[index].detail;
      this.tempIndex = index;
      this.initialindex = index;

    },
    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      this.mobiePhoneShow = oWidth < 768 ? true : false;
      if (oWidth < 1439) {
        // 600到1439像素之间的样式处理
        this.pageSmallBool = true;
        this.pagerCount = 5;
      } else {
        this.pageSmallBool = false;
        this.pagerCount = 7;
      }
    },
    // 切换方式0 左切   1  右切
    async handleCarouselChange(type) {

      if(type == 0){

        if(this.currentPage == 1){
          return
        }

        this.currentPage--;
        this.initialindex = this.currentPage == 1?0:1;
        await this.loadGalleryData()

      }else if(type == 1){

        let endPageNum = Number.parseInt(Math.ceil(this.total / this.currentSize))
        if(this.currentPage == endPageNum){
          return;
        }

        this.currentPage++;
        this.initialindex = 1;
        await this.loadGalleryData()

      }


      this.$nextTick(()=>{
        //显示点击的图片
        this.$refs.carouseTopRef.setActiveItem(this.initialindex);
        this.$refs.carouseTopMobielRef.setActiveItem(this.initialindex);
      })


      // let length = this.dataList.length;
      // let index = this.initialindex;
      //
      // if(length == 1){
      //   return
      // }
      //
      // // 大于4 显示并且可以切换 循环播放
      // let concatDataList = this.dataList.concat(this.dataList);
      // if (type == 0) {
      //   let leftStartIndex = index-1;
      //
      // } else if (type == 1) {
      //   let rightStartIndex = index+1;
      // }
      //
      // this.$refs.carouseTopRef.setActiveItem(
      //   type == 0 ? leftStartIndex : rightStartIndex
      // );
      // this.imageTitle = concatDataList[index].title;


    },
    async toImageDetail(index) {
      this.initialindex = this.currentPage == 1?index:index+1;
      await this.loadGalleryData();
      this.isShowImageDetail = true;

    },

    quickSearch() {
      this.isShowImageDetail = false;
      this.currentPage = 1;
      this.currentSize = 10;
      this.getDataList(
        this.currentPage,
        this.currentSize,
        this.asidId,
        this.searchValue
      );
    },
    getDataList(page, size, funcId, searchValue) {
      getDataListApi(page, size, funcId, searchValue).then((res) => {
        this.dataList = res.rows;
        this.total = res.total;
      });
    },
    getFuncList() {
      var tmpasidId = this.asidId;

      getFunctionListApi((this.funcId = 17)).then((res) => {
        if (res.data.length > 0) {
          this.asidMenuList = res.data;
          var tmprouterName = res.data[0].name;
          this.asidMenuList.forEach((item, index) => {
            if (item.id == tmpasidId) {
              tmprouterName = item.name;
            }
          });
          this.routerName = tmprouterName;
          this.asidId = (tmpasidId ? tmpasidId : res.data[0].id).toString();

          this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
        } else {
          this.asidId = this.funcId.toString();
          this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
        }
      });
    },
    handleToggleImage(index) {

      this.$refs.carouseTopRef.setActiveItem(index);
    },
    clickAsidMenu(index) {
      this.openType = 0;
      this.isShowImageDetail = false;
      this.searchValue = "";
      this.$router.push({
        path: "/imageCenter",
        query: { id: index, time: new Date().getTime() },
      });
    },
    handlePageChange(val) {
      this.currentPage = val;
      window.scrollTo(0, 0);
      this.getDataList(
        this.currentPage,
        this.currentSize,
        this.asidId,
        this.searchValue
      );
    },

    swiperNext() {
      this.$refs.mySwiper.swiper.slideNext()
    },
    swiperPrev() {
      this.$refs.mySwiper.swiper.slidePrev()
    },
    imgLoad(index){
      this.$nextTick(() => {
        console.log( "event" ,this.$refs['imgpcRef' + index][0].height)

        this.$set(this.imgpcHeightList,index,this.$refs['imgpcRef' + index][0].height)

      })

    },
    async dialogShowImageOpen() {

      this.$nextTick(() => {
        //计算img高度
        let windHeight = window.clientHeight || document.documentElement.clientHeight;
        this.iconHeioght = windHeight - this.$refs.myImgRef.offsetHeight - 70;

        if(this.iconHeioght < 500){
          this.iconHeioght = 500
        }

        //显示点击的图片
        this.$refs.carouseTopRef.setActiveItem(this.initialindex);
        this.$refs.carouseTopMobielRef.setActiveItem(this.initialindex);


      })


    },
    async loadGalleryData() {

      let tempList = [];
      if(this.currentPage == 1){
        for (let i = 0; i < 2; i++) {
          let res = await getDataListApi(
              this.currentPage + i,
              this.currentSize,
              this.asidId,
              this.searchValue
          )

          this.total = res.total;

          if(i == 1){
            tempList.push(...res.rows.slice(0,1) )
          }else {
            tempList.push(...res.rows)
            this.dataList = res.rows;
          }

        }
      }else {
        for (let i = 2; i > 0; i--) {
          let res = await getDataListApi(
              this.currentPage - (i - 1),
              this.currentSize,
              this.asidId,
              this.searchValue
          )

          this.total = res.total;

          if(i == 2){
            tempList.push(...res.rows.slice(res.rows.length - 1,res.rows.length) )
          }else {
            tempList.push(...res.rows)
            this.dataList = res.rows;
          }

        }
      }

      this.tempDataList = tempList;
      this.galleryIndex =  this.initialindex;

      this.imageTitle = this.tempDataList[this.initialindex].title;
      this.richText = this.tempDataList[this.initialindex].detail;


    },
    async moveChangeSwiper(type){ // 0左移动 1右移动

      let moveIndex = this.initialindex;
      if(type == 0){
        moveIndex = moveIndex - 1 ;
        if(moveIndex < 0){
          if(this.currentPage == 1){
            return
          }else {
            this.currentPage = this.currentPage - 1;
            this.initialindex = this.currentSize;
            moveIndex = this.initialindex;
            await this.loadGalleryData()
          }

        }
      }else if(type == 1){
        moveIndex =  moveIndex + 1;
        if(moveIndex >= this.tempDataList.length){ //一行显示10条数据
          let endPageNum = Number.parseInt(Math.ceil(this.total / this.currentSize))
          if(this.currentPage == endPageNum){
            return;
          }else {
            this.currentPage = this.currentPage + 1;
            this.initialindex = 0;
            moveIndex = this.initialindex;
            await this.loadGalleryData()
          }

        }
      }

      this.galleryIndex = moveIndex;

      this.$nextTick(()=>{
        //显示点击的图片
        this.$refs.carouseTopRef.setActiveItem(moveIndex);
        this.$refs.carouseTopMobielRef.setActiveItem(moveIndex);
      })

    }

  },
  beforeRouteUpdate(to, from, next) {
    this.asidId = to.query.id;
    this.getFuncList();
    this.isShowImageDetail = false;
    next((vm) => {});
  },
  computed: {
    swiper() {
      if(this.bannerList.length > 0){
        return this.$refs.mySwiper.swiper;
      }else {
        return  null
      }

    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.background-image {
  min-width: 120rem; /* 设置div的宽度 */
  margin: 0 12rem;
  height: 100%; /* 设置div的高度 */
  background-clip: content-box;
  background-repeat: no-repeat;
  background-position: center; /* 背景图片居中 */
  color: #fff;
  background-size: 100% 100%;
}
::v-deep .el-carousel__indicators {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

::v-deep .el-carousel__indicators {
}

.banner-block {
  display: flex;
  flex-direction: column;

  .background-image-bgbox{
    min-width: 120rem; /* 设置div的宽度 */
    height: 100%; /* 设置div的高度 */
    .background-image-bg{
      width: 100%;
      height: 100%;
      position: relative;
    }
  }

  .carousel_title {
    margin: 85px 0 0 38px;
    font-size: 40px;
    min-height: 52px;
    width: 90vw;
    line-height: normal;
    font-weight: 700;
  }
  .carousel_description {
    margin: 6px 0 0 38px;
    font-size: 18px;
    width: 90vw;
    line-height: normal;
    min-height: 52px;
    font-weight: 400;
  }
  .carousel_button {
    margin: 22px 0 0 38px;
    font-size: 14px;
    width: 90vw;
    min-height: 52px;
    font-weight: 400;
  }
}

.background-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背景下 */
}

.breadcrumb-search {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px 12rem 20px 12rem;
  .breadcrumb-block {
    width: 100%;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    justify-content: center;

    .breadcrumb-block-content{
      width: 96rem;
      .el-breadcrumb {
        height: 20px;
        span {
          font-size: 14px;
          width: 85px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
        }
      }

    }

    .custom-bead-box{
      padding-left: 30px;
      display: flex;
      flex-direction: row;
      .bead-box-item{
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        height: 20px;
        color: #0e517a;
        line-height: 20px;
        flex-shrink: 0;

        .bead-box-item-line{
          width: 1px;
          height: 9px;
          margin: 0 10px;
          background-color: #DFDFDF;
        }

      }

      .bead-box-item-active {
        color: #939395;
      }

    }


  }
  .search-block {
    margin-right: 16rem;
    width: 290px;
    height: 32px;
    .search-input {
      margin-top: -4px;
      .el-input__inner {
      }
      .serach-button {
        background-color: #255077;
        height: 100%;
      }
    }
  }
}

.page-content {
  display: flex;
  flex-direction: row;
  width: 120rem;
  justify-content: center;
  .asid-menu-block {
    width: 20rem;
    border-bottom: 0px;
    margin-bottom: 20px;

    ul {
      border-left: 2px solid #255077;
      border-right: 0;
      .el-menu-item {
        font-weight: 400;
        font-size: 20px !important;
        color: #6f7288 !important;
      }
      .is-active {
        background-color: #fff !important;
        color: #255077 !important;
        border-top: 2px solid #f9f9fa;
        border-left: 2px solid #f9f9fa;
        border-bottom: 2px solid #f9f9fa;
        font-weight: bolder !important;
        position: relative;
        &::after {
          width: 6px;
          height: 6px;
          border-top: 2px solid;
          border-right: 2px solid;
          border-color: #255077;
          content: "";
          position: absolute;
          left: 120px;
          top: 26px;
          transform: rotate(45deg);
        }
      }
    }
  }
  .asid-hor-menu-block {
    margin-bottom: 20px;
    width: 128rem;
    .el-menu--horizontal {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      div {
        width: 40rem;
        .el-menu-item {
          font-size: 13px !important;
          font-weight: 400;
          color: #74727d;
          text-align: center;
        }
        .is-active {
          background-color: #fff !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          border-bottom: 2px solid #2e4d75;
          span {
            color: #255077 !important;
          }
          :hover {
            span {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}

.image-block {

  display: flex;
  flex-direction: column;

  .image-list {
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: repeat(3, 30.7rem);
    grid-column-gap: 2rem;
    grid-row-gap: 30px;

    .image-item {
      width: 31.5rem;
      min-height: 285px;
      background-color: #f7f7f7;
      .image-item-block {
        display: flex;
        flex-direction: column;
        .image-item-img {
          width: 100%;
          height: auto;
        }
        .image-item-text {
          font-weight: 500;
          text-align: center;
          font-size: 16px;
        }
      }
    }
  }

  .pagination-block {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .el-pagination {
      ::v-deep .el-pagination__jump {
        margin-left: 0 !important;
      }
    }
  }

}

.my-showimage-dialog{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);

  .image-detail-block {
    position: relative;

    .close-badge-box{
      position: absolute;
      width: 150px;
      height: 120px;
      top: 0;
      right: 0;
      z-index: 99;
      cursor: pointer;
      .close-badge{
        position: absolute;
        width: 28px;
        height: 28px;
        top: 18px;
        right: 18.54px;

      }
    }

    .image-detail-carouselbox{
      display: flex;
      flex-direction: column;
      width: 100%;
      box-sizing: border-box;
      position: relative;

      .my-carousel-pre{
        user-select: none;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: rotate(180deg);
        position: absolute;
        top:0;
        height: 100%;
        left: 0;
        width: 45%;
        z-index: 80;
        img{
          width: 60px;
          height: 60px;
          transform: rotate(-180deg);
          position: absolute;
          right: 36px;
          bottom:52%;
        }
      }

      .my-carousel-next{
        user-select: none;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: rotate(180deg);
        position: absolute;
        top:0;
        height: 100%;
        right: 0;
        width: 45%;
        z-index: 80;
        img{
          width: 60px;
          height: 60px;
          position: absolute;
          left: 36px;
          bottom:52%;
        }
      }

    }

    .image-detail-carousel {
      width: 100%;
      .image-detail-carousel-item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        .image-carousel-item-icon {
          display: flex;
          flex-direction: column;
          justify-content: center;
          border: 3px solid #FFFFFF;
          box-sizing: border-box;
        }



      }
      ::v-deep .el-carousel__arrow {
        width: 70px;
        height: 120px;
        font-size: 28px;
        border-radius: 0;
        z-index: 4;
        opacity: 1;
        background: rgba(0, 0, 0, 0.35);
      }
      ::v-deep .el-carousel__arrow--left {
        left: 0;
      }
      ::v-deep .el-carousel__arrow--right {
        right: 0;
      }
    }
    .my-img-box{
      display: flex;
      flex-direction: column;
      position: relative;
    }
    .image-carousel-item-title {
      text-align: center;
      min-height: 49px;
      &>span{
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0.1em;
        line-height: 49px;
        color: #fff;
        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
      }

      .rich-box{
        margin-top: 10px;
        margin-bottom: 16px;
        .rich-text{
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          letter-spacing: 0.1em;

          font-variation-settings: "opsz" auto;
          font-feature-settings: "kern" on;
          color: #fff;

          text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
        }
      }

    }

    .carousel-sublist {
      padding: 0 34px;
      height: 107px;
      display: flex;
      position: relative;
      border-radius: 4px;

      width: 100%;
      background: #434343;
      box-sizing: border-box;
      .carousel-sublist-btn {
        cursor: pointer;
        position: absolute;
        z-index: 20;
        width: 34px;
        height: 107px;
        opacity: 1;
        background: #696969;
        border: 0;
        .icon-arrow {
          color: #fff;
        }
      }
      .carousel-sublist-btn-left {
        left: 0;
        border-radius: 4px 0 0 4px;
      }
      .carousel-sublist-btn-right {
        right: 0;
        border-radius: 0 4px 4px 0;
      }


      .carousel-sublist-layout{
        position: relative;
        width: 100%;
        .carousel-sublist-position{
          width: 100%;
          position: relative;
          display: flex;
          .carousel-sublist-item {
            box-sizing: border-box;
            padding-left: 17px;
            display: flex;
            flex-direction: column;
            justify-content: start;
            position: relative;

            .sublist-item-block {
              flex-direction: column;
              justify-content: flex-start;
              align-content: center;
              align-items: center;

              &:last-child {
                margin-right: 0;
              }
              .sublist-item-icon {
                margin: 15px 0;
                width: 100px;
                height: 75px;
              }
              .sublist-item-title {
                text-align: center;
                height: 46px;
                line-height: 46px;
                font-weight: 500;
                font-size: 16px;
                background-color: #fff;
              }
            }
          }
        }

      }

      .sublist-item-icon-active{
        padding: 5px;
        box-sizing: border-box;
        background-color: #fff;
      }


    }
  }


}

.image-detail-block-h5 {
  display: none;
  padding: 0 10px;

  .image-detail-carousel {
    width: 100%;
    background-color: #fff;
    .image-detail-carousel-item {
      .image-carousel-item-icon {
        height: 66rem;
      }
    }
    ::v-deep .el-carousel__arrow {
      height: 100%;
      border-radius: 0;
      z-index: 4;
      opacity: 1;
      background: rgba(0, 0, 0, 0.35);
    }
    ::v-deep .el-carousel__arrow--left {
      left: 0;
    }
    ::v-deep .el-carousel__arrow--right {
      right: 0;
    }
  }
  .image-carousel-item-title {
    text-align: center;
    min-height: 49px;
    &>span{
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.1em;
      line-height: 49px;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #FFFFFF;
      text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    }

    .rich-box{
      margin-top: 20px;
      margin-bottom: 16px;
      .rich-text{
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 24px;
        letter-spacing: 0.1em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #FFFFFF;

        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
      }
    }


  }
  .carousel-sublist {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    .carousel-sublist-btn {
      position: absolute;
      height: 100%;
      position: absolute;
      width: 36px;
      opacity: 1;
      background: rgba(0, 0, 0, 0.35);
      border: 0;
      .icon-arrow {
        color: #fff;
      }
    }
    .carousel-sublist-btn-left {
      left: 0;
    }
    .carousel-sublist-btn-right {
      right: 0;
    }
    .carousel-sublist-item {
      display: flex;
      flex-direction: column;
      justify-content: start;
      .sublist-item-block {
        width: 24rem;
        flex-direction: column;
        justify-content: start;
        align-content: center;
        align-items: center;
        &:last-child {
          margin-right: 0;
        }
        .sublist-item-icon {
          width: 100%;
          height: 160px;
        }
        .sublist-item-title {
          text-align: center;
          height: 46px;
          line-height: 46px;
          font-weight: 500;
          font-size: 16px;
          background-color: #fff;
        }
      }
    }
  }
}


.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {

  .image-detail-block{
    display: block;
  }

  .image-detail-block-h5{
    display: none;
  }

}

@media only screen and (max-width: 1439px) {
  .background-image {
    width: 100%;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 0 auto;
    height: 100%; /* 设置div的高度 */
  }

  .contain-block {
    width: 120rem;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 40px 12rem 0 0;
  }

  .image-detail-block{
    display: block;
  }

  .image-detail-block-h5{
    display: none;
  }

}
@media only screen and (max-width: 1330px) {
}
@media only screen and (max-width: 1200px) {

  :deep(.el-dialog){
    width: 1052px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }


  :deep(.el-dialog__body){
    width: 1052px !important;
    padding: 0 ;
  }


}
@media only screen and (max-width: 992px) {

  .my-swiper-box{
    .custom-carousel{


      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }

  .breadcrumb-search {
    flex-direction: column;
    justify-content: start;
    align-items: start;

    .breadcrumb-block {
      width: 280px;
      font-weight: 400;
      display: flex;
      margin-left: 0;
      flex-direction: row;

      .el-breadcrumb {
        span {
          font-size: 14px;
          width: 85px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
        }
      }
    }

    .search-block {
      width: 120rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 20px;

      div {
        width: 290px;
        height: 32px;

        .search-input {
          .serach-button {
            background-color: #255077;
            height: 100%;
          }
        }
      }
    }
  }
  .common-block {
    margin: 0 12rem;
    width: 120rem;
  }
  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .el-menu-item {
          font-weight: 400;
          font-size: 12px !important;
          color: #6f7288 !important;
          position: relative;
        }
        .is-active {
          &::after {
            left: 70px;
          }
        }
      }
    }
  }

  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .el-menu-item {
          font-weight: 400;
          font-size: 12px !important;
          color: #6f7288 !important;
          position: relative;
          &::after {
            display: none;
          }
        }
      }
    }
  }

  .image-block {
    width: 100.5rem;
    .image-list {
      width: 100.5rem;
      display: flex;
      flex-wrap: wrap;
      .image-item {
        width: 48rem;
        .image-item-block {
          .image-item-img {
            width: 100%;
            height: auto;
          }
          .image-item-text {
            font-weight: 500;
            text-align: center;
            font-size: 16px;
          }
        }
      }
    }

  }

  .image-detail-block {
    display: block;
    .image-detail-carousel {
      width: 100%;
    }
    .carousel-sublist {
      //height: 240px;
      .carousel-sublist-item {
        margin-right: 10px;
        .sublist-item-block {
          &:last-child {
            margin-right: 0;
          }
          .sublist-item-icon {
            width: 100%;
            height: 165px;
          }
          .sublist-item-title {
            text-align: center;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
          }
        }
      }
    }
  }

  .image-detail-block-h5 {
    display: none;
    width: 100.5rem;
    .image-detail-carousel {
      width: 100%;
    }
    .carousel-sublist {
      //height: 240px;
      margin-bottom: 59px;
      .carousel-sublist-item {
        margin-right: 10px;
        .sublist-item-block {
          width: 24rem;
          &:last-child {
            margin-right: 0;
          }
          .sublist-item-icon {
            width: 100%;
            height: 165px;
          }
          .sublist-item-title {
            text-align: center;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
          }
        }
      }
    }
  }


  :deep(.el-dialog){
    width: 890px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }


  :deep(.el-dialog__body){
    width: 890px !important;
    padding: 0 ;
  }


}
@media only screen and (max-width: 768px) {



  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }

  .breadcrumb-search {
    width: 128rem;
    margin: 20px 8rem 20px 8rem;
    .search-block {
      width: 128rem;
    }
  }

  .page-content {
    flex-direction: column;
    .asid-menu-block {
      width: 90px;
    }

    .image-block {
      width: 128rem;
      .image-list {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .image-item {
          width: 48%;
          margin-left: 0rem;
          height: 185px;
          min-height: 185px;
          .image-item-block {
            .image-item-img {
              width: 100%;
              height: 125px;
            }
            .image-item-text {
              font-weight: 500;
              text-align: center;
              font-size: 16px;
            }
          }
        }
      }


    }
  }

  .image-detail-block {
    display: none;
    width: 100%;
    .image-detail-carousel {
      width: 100%;
      .image-detail-carousel-item {
        .image-carousel-item-title {
          text-align: center;
          min-height: 49px;
          line-height: 49px;
        }
      }
    }
    .carousel-sublist {
      // height: 200px;
      flex-direction: columns;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .carousel-sublist-item {
        width: 90rem;
        margin-right: 0;
        box-sizing: border-box;
        .sublist-item-block {
          height: 200px;
          width: 100%;
          &:last-child {
            margin-right: 0;
          }
          .sublist-item-icon {
            width: 100%;
            height: 160px;
          }
          .sublist-item-title {
            text-align: center;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
          }
        }
      }
    }
  }

  .image-detail-block-h5 {
    display: block;
    width: 100%;
    box-sizing: border-box;
    .image-detail-carousel {
      width: 100%;
      .image-detail-carousel-item {
        .image-carousel-item-title {
          text-align: center;
          min-height: 49px;
          line-height: 49px;

          .rich-box{
            margin-top: 10px;
            margin-bottom: 16px;
            .rich-text{
              font-family: Source Han Sans;
              font-size: 16px;
              font-weight: normal;
              line-height: 24px;
              letter-spacing: 0.1em;

              font-variation-settings: "opsz" auto;
              font-feature-settings: "kern" on;
              color: #FFFFFF;

              text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
            }
          }

        }
      }
    }
    .carousel-sublist {
      // height: 200px;
      flex-direction: columns;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .carousel-sublist-item {
        width: 100%;
        margin-right: 0;
        box-sizing: border-box;
        .sublist-item-block {
          height: 200px;
          width: 100%;
          &:last-child {
            margin-right: 0;
          }
          .sublist-item-icon {
            width: 100%;
            height: 160px;
          }
          .sublist-item-title {
            text-align: center;
            height: 20px;
            line-height: 20px;
            font-size: 16px;
          }
        }
      }
    }
  }


  .common-block {
    width: 128rem;
    margin: 0 8rem;
    padding-left: 0;
  }

  :deep(.el-dialog){
    width: 100% !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }


  :deep(.el-dialog__body){
    width: 100% !important;
    padding: 0 !important;
  }


}
@media only screen and (max-width: 520px) {

  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }

  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .is-active {
          &::after {
            left: 80px;
          }
        }
      }
    }
  }
  .pagination-block {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .el-pagination {
      ::v-deep .el-pagination__jump {
        margin-left: 0 !important;
      }
    }
  }

  .image-detail-block{
    display: none;
  }

  .image-detail-block-h5{
    display: block;
  }


}




.my-swiper-box{
  width: 100%;
  min-width: 120rem; /* 设置div的宽度 */
  height: 100%; /* 设置div的高度 */
  position: relative;

  &:hover {

    :deep(.swiper-button-prev){
      display: flex !important;
      width: 36px;
      height: 36px;
      top: 50%;
      transform: translateY(10%);
      opacity: 1;
      background: rgba(0,0,0,0.1);
      .el-icon-arrow-left{
        width: auto;
        height: auto;
        display: inline-block;
      }
    }

    :deep(.swiper-button-next){
      display: flex !important;
      width: 36px;
      height: 36px;
      top: 50%;
      border-radius: 18px;
      transform: translateY(10%);
      background: rgba(0,0,0,0.1);
      opacity: 1;
      .el-icon-arrow-right{
        width: auto;
        height: auto;
        display: inline-block;
      }
    }

  }



  :deep(.swiper-button-prev){

    //display: none !important;
    transition: all 0.2s ease-in-out;
    width: 0px;
    height: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border-radius: 18px;
    background: rgba(0,0,0,0);
    opacity: 0;
    top: 50%;
    transform: translateY(10%);

    &:after {
      font-size: 1.1rem;
      color: #fff;

    }

    .el-icon-arrow-left{
      width: 0;
      height: 0;
      display: none;
    }

  }

  :deep(.swiper-button-next){

    //display: none !important;
    transition: all 0.2s ease-in-out;
    width: 0px;
    height: 0px;
    display: flex;
    opacity: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border-radius: 1.8rem;
    background: rgba(0,0,0,0);
    top: 50%;
    transform: translateY(10%);
    &:after {
      font-size: 1.1rem;
      color: #fff;

    }

    .el-icon-arrow-right{
      width: 0;
      height: 0;
      display: none;
    }

  }


}

.my-swiper-box-bg{
  width: 100%;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背 下 */
}

:deep(.swiper-pagination){
  bottom: 7px;
}
/* Swiper指示器的自定义样式 */
:deep(.swiper-pagination-bullet) {

  opacity: .48;
  width: 30px;
  height: 2px;
  background-color: #fff;
  border-radius: 10px;
  /* 其他样式按需修改 */
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #fff;
  opacity: 1;
  /* 激活状态下的样式按需修改 */
}


:deep(.el-dialog){
  width: 1252px;
  background: transparent;
  box-shadow: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

:deep(.el-dialog__header){
  display: none;
}


:deep(.el-dialog__body){
  width: 1252px;
  padding: 0 ;
}

:deep(.el-overlay){
  .el-overlay-dialog{
    .el-dialog{
      .el-dialog__body{
        padding: 0 !important;
      }
    }
  }

}


</style>
